import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';
import { faCheck, faTimes } from '@fortawesome/pro-regular-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography } from '@comparethemarketau/manor-typography';

const useStyles = createUseStyles((theme) => ({
    iconCellOptionalWrap: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    iconCellWrap: {
        display: 'flex'
    },
    check: {
        color: theme.colors.success500,
        fontSize: theme.fontSize['3xl'],
        marginRight: '0.8rem'
    },
    cross: {
        color: theme.colors.error500,
        fontSize: theme.fontSize['3xl'],
        marginRight: theme.spacing[8]
    },
    optional: {
        marginBottom: theme.spacing[20]
    }
}));

const IconCell = ({ description, value, title }) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    if (!value) {
        return <Typography variant="srOnly">{`${title} - no data supplied`}</Typography>;
    }

    return (
        <>
            { value === 'Y'
                && (
                    <div className={classes.iconCellWrap}>
                        <Typography variant="srOnly">{`${title} - is covered`}</Typography>
                        <span className={classes.check}>
                            <FontAwesomeIcon icon={faCheck} />
                        </span>
                        { description }
                    </div>
                )}
            { value === 'N'
                && (
                    <div className={classes.iconCellWrap}>
                        <Typography variant="srOnly">{`${title} - is not covered`}</Typography>
                        <span className={classes.cross}>
                            <FontAwesomeIcon icon={faTimes} />
                        </span>
                        { description }
                    </div>
                )}
            { value === 'O'
                && (
                    <div className={classes.iconCellOptionalWrap}>
                        <Typography variant="srOnly">{`${title} - is available as an optional extra`}</Typography>
                        <div className={classes.optional}>
                            Optional
                        </div>
                        { description }
                    </div>
                )}
        </>
    );
};

IconCell.propTypes = {
    description: PropTypes.string,
    value: PropTypes.string,
    title: PropTypes.string.isRequired
};

export { IconCell };
